import { REDIRECTION_URL } from "store/api/constApi";

export const normalizePortalVanityUrl = (
  vanityUrl: unknown,
  fallbackOrigin: string = REDIRECTION_URL
): string => {
  const fallbackUrl = `${fallbackOrigin || "/"}`.trim() || "/";
  const normalizedFallbackUrl = `${fallbackUrl.replace(/\/+$/, "")}/`;
  const value = typeof vanityUrl === "string" ? vanityUrl.trim() : "";

  if (!value) {
    return normalizedFallbackUrl;
  }

  try {
    let fallbackProtocol = "https:";

    try {
      const protocol = new URL(normalizedFallbackUrl).protocol;
      if (protocol === "http:" || protocol === "https:") {
        fallbackProtocol = protocol;
      }
    } catch {
      // Keep HTTPS when the fallback is relative or otherwise not a full URL.
    }

    const hasExplicitProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(value);
    const hasUnsupportedScheme =
      /^[a-z][a-z\d+.-]*:/i.test(value) &&
      !hasExplicitProtocol &&
      !/^[a-z\d.-]+:\d+(?:[/?#]|$)/i.test(value);

    if (hasUnsupportedScheme) {
      return normalizedFallbackUrl;
    }

    const vanityUrlWithProtocol = hasExplicitProtocol
      ? value
      : value.startsWith("//")
        ? `${fallbackProtocol}${value}`
        : `${fallbackProtocol}//${value.replace(/^\/+/, "")}`;
    const url = new URL(vanityUrlWithProtocol);

    if (
      (url.protocol !== "http:" && url.protocol !== "https:") ||
      !url.hostname
    ) {
      return normalizedFallbackUrl;
    }

    url.search = "";
    url.hash = "";
    url.pathname = `${url.pathname.replace(/\/+$/, "")}/`;

    return url.toString();
  } catch {
    return normalizedFallbackUrl;
  }
};

export const resolvePortalBaseUrl = (
  vanityUrl: unknown,
  domain: unknown,
  redirectionUrl: string = REDIRECTION_URL
): string => {
  const normalizedRedirectionUrl = normalizePortalVanityUrl(
    undefined,
    redirectionUrl
  );
  const normalizedDomain = normalizePortalVanityUrl(
    domain,
    normalizedRedirectionUrl
  );

  return normalizePortalVanityUrl(vanityUrl, normalizedDomain);
};
